/**
 * EInvoicing API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  getEInvoicingSettings,
  getEInvoicingSubmission,
  getEInvoicingSupplier,
  handleFlowinWebhook,
  listEInvoicingSubmissions,
  registerEInvoicingSupplier,
  retryEInvoicingSubmission,
  searchEInvoicingCustomer,
  sendEInvoice,
  updateEInvoicingSettings,
} from "../generated/e-invoicing/e-invoicing";

import { wrapMethod } from "./utils";

export const eInvoicing = {
  /** @see getEInvoicingSettings */
  list: wrapMethod(getEInvoicingSettings),

  /** @see updateEInvoicingSettings */
  update: wrapMethod(updateEInvoicingSettings),

  /** @see registerEInvoicingSupplier */
  registerEInvoicingSupplier: wrapMethod(registerEInvoicingSupplier),

  /** @see getEInvoicingSupplier */
  getEInvoicingSupplier: wrapMethod(getEInvoicingSupplier),

  /** @see searchEInvoicingCustomer */
  searchEInvoicingCustomer: wrapMethod(searchEInvoicingCustomer),

  /** @see sendEInvoice */
  sendEInvoice: wrapMethod(sendEInvoice),

  /** @see listEInvoicingSubmissions */
  listEInvoicingSubmissions: wrapMethod(listEInvoicingSubmissions),

  /** @see getEInvoicingSubmission */
  getEInvoicingSubmission: wrapMethod(getEInvoicingSubmission),

  /** @see retryEInvoicingSubmission */
  retryEInvoicingSubmission: wrapMethod(retryEInvoicingSubmission),

  /** @see handleFlowinWebhook */
  handleFlowinWebhook: wrapMethod(handleFlowinWebhook),
} as const;

export type EInvoicingApi = typeof eInvoicing;
